// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit';

if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill");
}

import { setDebug } from '@thepassle/app-tools/utils/log.js';
// setDebug(true);

import { Router } from '@thepassle/app-tools/router.js';
import { checkServiceWorkerUpdate } from '@thepassle/app-tools/router/plugins/checkServiceWorkerUpdate.js';

import './pages/app-fast.js';
import './pages/app-info.js';
import './pages/app-settings.js';
import './pages/app-flux.js';

const baseURL: string = (import.meta as any).env.BASE_URL;

export const router = new Router({
    /** Plugins to be run for every route */
    plugins: [
      /** Checks for service worker updates on route navigations */
      checkServiceWorkerUpdate,
    ],
    routes: [
      {
        path: resolveRouterPath(),
        title: 'Fasting',
        render: () => html`<app-fast></app-fast>`
      },
      {
        path: resolveRouterPath('session/:id'),
        title: ({params}) => `Sessions/${params.id}`,
        render: (page) => html`<app-fast .page=${page}></app-fast>`,
      },
      {
        path: resolveRouterPath('info'),
        title: 'Info',
        render: () => html`<app-info></app-info>`
      },
      {
        path: resolveRouterPath('settings'),
        title: 'Settings',
        render: () => html`<app-settings></app-settings>`
      },

       {
        path: resolveRouterPath('flux'),
        title: 'Flux',
        render: () => html`<app-flux></app-flux>`
      },


    ]
  });

  // window.router = router;

  // This function will resolve a path with whatever Base URL was passed to the vite build process.
  // Use of this function throughout the starter is not required, but highly recommended, especially if you plan to use GitHub Pages to deploy.
  // If no arg is passed to this function, it will return the base URL.

  export function resolveRouterPath(unresolvedPath?: string) {
    var resolvedPath = baseURL;
    if(unresolvedPath) {
      resolvedPath = resolvedPath + unresolvedPath;
    }

    return resolvedPath;
  }
